import ClassInvitation from '@/modules/class/models/ClassInvitation'
export default {
  namespaced: true,
  actions: {
    async createInvitations({ _dispatch }, { payload }) {
      try {
        const classInvitations = await this._vm.axios.post(
          'api/custom-classes/class-invitations',
          {
            students: payload.students,
            custom_class_id: payload.class_id,
            module: 'teacher'
          }
        )
        ClassInvitation.insert({ data: classInvitations }, { root: true })
      } catch (error) {
        throw error
      }
    },
    async acceptInvitation({ _dispatch }, { classCode }) {
      try {
        const classInvitations = await this._vm.axios.post(
          `api/students/class-invitations/${classCode}`
        )
        ClassInvitation.insert({ data: classInvitations }, { root: true })
      } catch (error) {
        throw error
      }
    },
    async getClassInvitations({ _dispatch }, { classId }) {
      try {
        const classInvitations = await this._vm.$axios.get(
          `api/teachers/custom-classes/${classId}/class-invitations`
        )
        ClassInvitation.insertOrUpdate(
          { data: classInvitations },
          { root: true }
        )
      } catch (error) {
        throw error
      }
    },
    async deleteClassInvitation({ _dispatch }, { classInvitationId }) {
      try {
        await this._vm.$axios.delete(
          `api/custom-classes/class-invitations/${classInvitationId}`,
          {
            module: 'teacher'
          }
        )
        ClassInvitation.delete(classInvitationId)
      } catch (error) {
        throw error
      }
    },
    async batchDeleteClassInvitation({ _dispatch }, { classInvitationIds }) {
      try {
        await this._vm.$axios.post(
          'api/custom-classes/deleted-class-invitations',
          {
            class_invitation_ids: classInvitationIds,
            module: 'teacher'
          }
        )
        ClassInvitation.delete(classInvitation => {
          return classInvitationIds.includes(classInvitation.id)
        })
      } catch (error) {
        throw error
      }
    }
  }
}
